/**
 * requestAnimationFrame as promised
 * Experimental: Use with precaution.
 */
export const rafPromise = (): Promise<number> =>
  new Promise<number>((resolve) => requestAnimationFrame(resolve));
